import { Minus, Plus } from 'lucide-react'

// จำนวน stepper — the one quantity control for the whole จัดซื้อ flow (สร้างคำขอซื้อ
// and the PO / คำขอซื้อ editor), so a qty looks and behaves the same everywhere.
//
// Value stays a STRING owned by the caller: typing has to be able to pass through
// an empty box, and clamping mid-keystroke would fight the user. It is normalized
// on blur instead, and − stops at `min` (1 — a purchase line for zero items is
// not a thing; removing the line is what you actually want).
//
// `max` is optional and only used where a ceiling is real — รับของ caps at what is
// still outstanding, so a delivery can never be recorded as more than was ordered.
export default function QtyStepper({ value, onChange, min = 1, max = null, disabled = false }) {
  const n = Math.trunc(Number(value) || 0)
  const capped = max != null ? Math.max(min, Math.trunc(max)) : null
  const valid = n >= min && (capped == null || n <= capped)
  const set = (v) => {
    let next = Math.max(min, Math.trunc(v) || min)
    if (capped != null) next = Math.min(capped, next)
    onChange(String(next))
  }

  return (
    <div className={`inline-flex items-stretch rounded-lg border overflow-hidden ${
      valid ? 'border-slate-200' : 'border-rose-300'} ${disabled ? 'opacity-50' : ''}`}>
      <button type="button" onClick={() => set(n - 1)} disabled={disabled || n <= min}
        aria-label="ลดจำนวน"
        className="px-2 text-slate-400 hover:bg-slate-50 hover:text-slate-700 disabled:opacity-30 disabled:hover:bg-transparent">
        <Minus size={13} />
      </button>
      <input value={value} disabled={disabled} inputMode="numeric" aria-label="จำนวน"
        onChange={(e) => onChange(e.target.value.replace(/[^\d]/g, ''))}
        onBlur={() => set(n)}
        className={`w-11 border-x border-slate-200 py-1.5 text-center text-[13.5px] tabular-nums outline-none ${
          valid ? 'text-slate-800' : 'bg-rose-50 text-rose-700'}`} />
      <button type="button" onClick={() => set(n + 1)} disabled={disabled || (capped != null && n >= capped)}
        aria-label="เพิ่มจำนวน"
        className="px-2 text-slate-400 hover:bg-slate-50 hover:text-slate-700 disabled:opacity-30">
        <Plus size={13} />
      </button>
    </div>
  )
}
